import React, { Component } from 'react';
import { connect } from 'react-redux';
import {reduxForm, Field, formValueSelector, getFormSubmitErrors, change} from 'redux-form';
import { withRouter } from 'react-router'
import StatesList from '../containers/StatesContainer.js';
import EmploymentsList from '../containers/EmploymentsContainer.js';
import CustomAlert from '../components/CustomAlert.js';
import asyncValidate from './Validations/asyncValidationsMainForm';
import RenderField from './RenderField';
import SelectField from './SelectField';
import CustomSpinner from './CustomSpinner';
import { HotKeys } from "react-hotkeys";

class MainForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.emailValue !== prevProps.emailValue && this.props.formSubmitErrors && this.props.formSubmitErrors.document_number) {
            this.props.dispatch(change('main', 'document_number', this.props.documentValue));
        }
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <HotKeys handlers={{SHOW_SELLER_CODE: this.showCodeField}}>
            <div>
                <form onSubmit={handleSubmit(this.props.addSubscriber)} className='pvc-form'>
                    {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                    {error && <CustomAlert bsStyle="danger" message={error}/>}
                    <div className={this.state.fields.hasOwnProperty('email') && this.state.fields.hasOwnProperty('document_number') ? 'row-hidden' : 'row' }>
                        <div className="col-md-12 col-lg-12">
                            <div className="form-group">
                                <Field className="form-control" name="email" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('email') ? 'hidden' : 'email'} label="Correo Electrónico" showSuccess={true} />
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <div className="form-group">
                                <Field className="form-control" name="document_number" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('document_number') ? 'hidden' : 'number'} label="Número de Documento" />
                            </div>
                        </div>
                    </div>
                    <div className={this.state.fields.hasOwnProperty('name') && this.state.fields.hasOwnProperty('gender') ? 'row-hidden' : 'row' }>
                        <div className="col-md-12 col-lg-12">
                            <div className="form-group">
                                <Field className="form-control" name="name" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('name') ? 'hidden' : 'text'} label="Nombre y Apellido"  />
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <div className="form-group">
                                <Field
                                    className="form-control"
                                    name="gender"
                                    autoComplete="off"
                                    component={SelectField}
                                    options={[{id: 'm', name: 'Masculino'}, {id: 'f', name: 'Femenino'}]}
                                    defaultValue={'Sexo según tu DNI'}
                                    label={'Género'}
                                    type={this.state.fields.hasOwnProperty('gender') ? 'hidden' : 'select'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={this.state.fields.hasOwnProperty('area_code') && this.state.fields.hasOwnProperty('number') ? 'row-hidden' : 'row' }>
                        <div className="col-md-4 col-lg-4">
                            <div className="form-group">
                                <Field className="form-control" name="area_code" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('area_code') ? 'hidden' : 'number'} label="Código de Area" showSuccess={true} />
                            </div>
                        </div>
                        <div className="col-md-8 col-lg-8">
                            <div className="form-group">
                                <Field className="form-control" name="number" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('number') ? 'hidden' : 'number'} label="Número de Celular" showSuccess={true} />
                            </div>
                        </div>
                    </div>
                    <div className={this.state.fields.hasOwnProperty('employment_id') && this.state.fields.hasOwnProperty('state_id') ? 'row-hidden' : 'row' }>
                        <EmploymentsList type={this.state.fields.hasOwnProperty('employment_id') ? 'hidden' : 'select'} />
                        <StatesList type={this.state.fields.hasOwnProperty('state_id') ? 'hidden' : 'select'} />
                        <Field className="form-control" name="site" autoComplete="off" component={RenderField} type="hidden" />
                    </div>
                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Solicitar</button>
                </form>
            </div>
            </HotKeys>
        );
    }
}

const selector = formValueSelector('main')

MainForm = connect(
    state => {
        const documentValue = selector(state, 'document_number')
        const emailValue = selector(state, 'email')
        const formSubmitErrors = getFormSubmitErrors('main')(state);

        return {
            documentValue,
            emailValue,
            formSubmitErrors
        }
    }
)(MainForm);

MainForm = reduxForm({
    initialValues: {
        site: ((process.env.PAGE === 'montemar' && 'Montemar.com.ar') ||
               (process.env.PAGE === 'montemar-adelantos' && 'Adelantos.montemar.com.ar') ||
               (process.env.PAGE === 'puedo' && 'Puedo.com.ar') ||
               (process.env.PAGE === 'demo' && 'Demo-Creditos.com.ar'))
    },
    form: 'main', // a unique name for this form
    asyncValidate,
    asyncBlurFields: ['email', 'area_code', 'number']
})(MainForm);

MainForm = withRouter(MainForm);

export default MainForm;



/** WEBPACK FOOTER **
 ** ./src/components/MainForm.js
 **/